<template>
  <vs-popup class="customer-site-create-popup"
            id="popup"
            title="VIEW CUSTOMER PROJECT BRIEF"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <template slot="actions">
        <vs-chip transparent :color="projectBriefColorFactory(createForm.status ? createForm.status.id : null)">
          status: {{ createForm.status ? createForm.status.name : '' }}
        </vs-chip>
      </template>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form autocomplete="off">

          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="project_brief_code" name="project_brief_code" rules="required" v-slot="{ errors }">
                <small class="label">Project brief code</small>
                <vs-input readonly v-model="createForm.project_brief_code"  name="project_brief_code" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="name" name="name" rules="required" v-slot="{ errors }">
                <small class="label">Name</small>
                <vs-input readonly v-model="createForm.name"  name="name" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <ValidationProvider vid="description" name="description" rules="" v-slot="{ errors }">
                <small class="label">Description and project notes (shared)</small>
                <vs-textarea readonly class="mb-0" v-model="createForm.description" height="100px" />
                <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>


          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <ValidationProvider vid="note" name="note" rules="" v-slot="{ errors }">
                <small class="label">ITS private notes on project brief (not shared with customer)</small>
                <vs-textarea readonly class="mb-0" v-model="createForm.note" height="100px" />
                <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const CustomerRepository = RepositoryFactory.get('customer')
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture');

  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  function initialState() {
    return {
      open: false,
      createForm: {
        address: {}
      },
      id: '',
      countryCodes: [],
      customerUsers: []
    }
  }

  export default {
    name: 'ViewProjectBriefPopUp',
    data () {
      return initialState()
    },
    methods:{
      async openPopup (id) {
        try {
          await Object.assign(this.$data, initialState())
          this.id = id
          this.$vs.loading();
          await this.fetchProjectBriefDetails()
          this.$vs.loading.close();
          this.open = true;
        } catch (error) {

        }
      },

      async fetchProjectBriefDetails() {
        this.$vs.loading()
        const {data} = await CustomerRepository.getCustomerProjectBriefDetails(this.id)
        this.createForm =  data.data
        this.$vs.loading.close()
      },
      projectBriefColorFactory(id) {
        switch (id) {
          case 1:
            return '#a0937d';
          case 2:
            return 'warning';
          case 3:
            return 'primary';
          case 4:
            return '#00adb5';
        }
      }
    },
    components: {
      'v-select': vSelect,
    },
    mixins: [SuccessMessage, ErrorMessages],
  }
</script>

<style scoped>
  .customer-site-create-popup >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 50% !important;
  }

</style>
